import { userLogout } from "@/lib/common";
import useCommonStore from "@/store/commonStore";
import axios from "axios"


const instance = axios.create({
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
})

instance.interceptors.request.use((config) => {
    if (typeof document !== "undefined") {
        const cookieStr = Array.isArray(document.cookie) ? document.cookie.join(';') : (document.cookie || '')
        const cookies = cookieStr
            .split(';')
            .map(s => s.trim())
            .reduce((acc: Record<string, string>, cookie) => {
                const [key, value] = cookie.split('=')
                if (key && value) {
                    acc[key] = decodeURIComponent(value)
                }
                return acc
            }, {})
        config.headers['lang'] = cookies['lang'] || 'EN'
        config.headers['currency'] = cookies['currency'] || 'AED'
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

instance.interceptors.response.use((response) => {
    return response
}, async(error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && !originalRequest._retry) {
        // originalRequest._retry = true
        // const refreshToken = ""
        // return axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/auth/refresh`, {refreshToken}).then((res)=>{
        //     if(res.status === 200){
        //         return instance(originalRequest)
        //     }
        // })
        
        await userLogout();
        window.location.href="/login"
    }
    return Promise.reject(error)
})


export default instance